export default {
  title: 'Importar relação de convênios',

  uploadSpace: {
    placeholder: 'Arraste e solte o arquivo aqui',
    placeholderDrag: 'Arraste e solte'
  },

  actions: {
    uploadFile: 'Importar arquivo',
    uploadServiceFile: 'Enviar relação de serviços',
    uploadProductFile: 'Enviar relação de produtos',
    replace: 'Substituir'
  },

  uploadHistoryGrid: {
    title: 'Histórico de importação',
    tooltipDownload: 'Baixar arquivo com a lista de erros de formatação',

    headers: {
      date: 'Data',
      file: 'Arquivo',
      size: 'Tamanho',
      status: 'Status',
      lastStatusUpdate: 'Data do último status',
      actions: 'Ações'
    },

    statuses: {
      uploadPending: 'Importação em andamento, por favor, aguarde.',
      uploadError: 'Houve um erro na importação. Por favor, tente novamente.',
      uploadComplete: 'Importação concluída com sucesso!',
      validationPending: 'Validação em andamento, por favor, aguarde.',
      validationError: 'Erro na validação'
    },
  },

  messages: {
    uploadSuccess: 'Dados importados com sucesso! Estamos aplicando as configurações. Isso pode levar alguns minutos, por favor, aguarde.',
    formatErrorsFound: 'O arquivo é inválido, seu formato não está em conformidade com os requisitos esperados.',
    invalidTypeFile: 'O tipo de arquivo não é permitido. Verifique os formatos aceitos.',
    downloadError: 'Erro ao baixar o arquivo.',
  },
}
